import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { useDispatch, useStore } from 'react-redux';

import { clearClientState, logout } from '#src/lib/auth';
import {
  setGeoLocation,
  setIsQaTeam,
  setSuperchargerInviteToken,
  setSuperchargerPromo,
} from '#src/store/session/actions';
import {
  selectGeoLocation,
  selectPersistedIsQaTeam,
  selectSuperchargerInviteToken,
  selectSuperchargerPromo,
} from '#src/store/session/selectors';

// Signs the visitor out mid Supercharger pay flow (the phone step, account
// merge v2, 2026-10-25), the way /logout does: the auth service drops the
// session cookie, then the browser's session storage, Apollo's cache and
// the redux session are cleared (clearClientState). Unlike /logout it keeps
// the flow's own state, which isn't the signed-out account's: the invite
// token, the promo code, QA mode and the geo location. The caller stores
// the number after this resolves, since the sign-out clears it too.
export function useSuperchargerSignOut() {
  const dispatch = useDispatch();
  const store = useStore();
  const graphqlClient = useApolloClient();

  return useCallback(async () => {
    const state = store.getState();
    const kept = {
      isQaTeam: selectPersistedIsQaTeam(state),
      geoLocation: selectGeoLocation(state),
      inviteToken: selectSuperchargerInviteToken(state),
      promo: selectSuperchargerPromo(state),
    };

    await logout();
    clearClientState({ dispatch, graphqlClient });

    dispatch(setIsQaTeam(kept.isQaTeam));
    dispatch(setGeoLocation(kept.geoLocation));
    dispatch(setSuperchargerInviteToken(kept.inviteToken));
    dispatch(setSuperchargerPromo(kept.promo));
  }, [dispatch, store, graphqlClient]);
}
